import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { OrderType } from '../../../../../core';

@JsonConverter
export class OrderTypeAdapter implements JsonCustomConvert<OrderType> {
    serialize(type: OrderType): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): OrderType {
        switch (type) {
            case 'S':
                return OrderType.SUBSCRIPTION;
            case 'SP':
                return OrderType.SUBSCRIPTION_PERIOD;
            case 'R':
                return OrderType.REFUND;
            case 'RP':
                return OrderType.REFUND_PERIOD;
            case 'E':
                return OrderType.EXTERNAL_TRANSFER;
            case 'I':
                return OrderType.INTERNAL_TRANSFER;
            default:
                return OrderType.SUBSCRIPTION;
        }
    }
}
